import React from 'react';
import { Box, Card, CardContent, Paper, Typography } from '@mui/material';
import CustomAppBar from '../../components/AppBar';
import { makeStyles } from '@mui/styles';
import { InsertDriveFile as InsertDriveFileIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: { width: '100%', minHeight: '100vh', marginBottom: '-4rem' },
  container: { padding: '20px', maxWidth: '1200px', margin: '0 auto' },
  title: {
    textAlign: 'center',
    padding: '20px 0',
    borderRadius: '4px',
    marginBottom: '20px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
  ItemContainer: {
    display: 'grid',
    gap: '20px',
    maxWidth: '900px',
    margin: 'auto',
  },
  card: {
    padding: '16px',
    textAlign: 'center',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    cursor: 'pointer',
  },
  label: {
    marginTop: '8px',
    fontWeight: 500,
  },
}));

const PaymentDetails = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();

  const Items = [
    {
      label: t('Subscription Invoices'),
      icon: <InsertDriveFileIcon sx={{ fontSize: 50 }} />,
      color: '#00BCD4',
      url: '/subscription-invoice',
    },
  ];

  return (
    <Box className={classes.root}>
      <CustomAppBar />

      <Box className={classes.container}>
        <Paper className={classes.title}>
          <Typography variant="h5">Payment Management DashBoard</Typography>
        </Paper>

        <Box className={classes.ItemContainer}>
          {Items.map((item, index) => (
            <Card
              key={index}
              className={classes.card}
              style={{ backgroundColor: item.color }}
              onClick={() => navigate(item.url)}
            >
              <CardContent>
                {item.icon}
                <Typography sx={{ fontSize: 25 }} className={classes.label}>
                  {item.label}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentDetails;
